import React from 'react';
import { classNames } from '../atoms';

interface OverlayPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  open?: boolean;
}

const OverlayPanel: React.FC<OverlayPanelProps> = ({
  open = true,
  className,
  children,
  ...props
}) => {
  if (!open) {
    return null;
  }

  return (
    <div
      className={classNames('position-absolute bg-light shadow-lg p-3 rounded', className)}
      {...props}
    >
      {children}
    </div>
  );
};

export default OverlayPanel;
